// The backend runs in UTC; this is an Australian lending tool, so every
// date/time shown to users must read as Sydney local time regardless of
// the viewing machine's own timezone - relying on the browser's implicit
// timezone (e.g. plain toLocaleString()) silently breaks for anyone on a
// machine not set to an AU timezone.
const AU_TIMEZONE = "Australia/Sydney";

// Today's calendar date in Sydney, as YYYY-MM-DD. Used to default an
// effective date input - new Date().toISOString() would give the UTC
// date, which is still "yesterday" in Sydney during roughly the first
// 10-11 hours of each Sydney day.
const todayIsoAEST = () => {
    const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone: AU_TIMEZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).formatToParts(new Date());
    const get = (type) => parts.find((p) => p.type === type).value;
    return `${get("year")}-${get("month")}-${get("day")}`;
};

// Formats a YYYY-MM-DD (date-only, no time component) for display, e.g.
// "1/10/2026". Safe to convert through Date/Sydney-timezone since Sydney
// is always ahead of UTC, so a UTC-midnight parse never rolls the date
// backwards onto the wrong day.
const formatDateAu = (isoDate) => {
    if (!isoDate) return "--";
    return new Date(isoDate).toLocaleDateString("en-AU", {
        timeZone: AU_TIMEZONE,
    });
};

// Formats a full ISO timestamp for display in Sydney local time, e.g.
// "1/10/2026, 2:35 pm".
const formatDateTimeAu = (isoDateTime) => {
    if (!isoDateTime) return "--";
    return new Date(isoDateTime).toLocaleString("en-AU", {
        timeZone: AU_TIMEZONE,
    });
};

export { todayIsoAEST, formatDateAu, formatDateTimeAu };
